import * as React from "react";
import { Link } from "react-router-dom";

import { getClassNames, NewHomePageClassNames } from "./NewHomePage.styles";

export function NewHomePage(): JSX.Element {
    const classNames: NewHomePageClassNames = getClassNames();
    return (
        <div className={classNames.root}>
            <div className={classNames.content}>
                <h1 className={classNames.header}>zach halasz</h1>
                <div className={classNames.submenu}>
                    <Link className={classNames.link} to="images">
                        <div>important images</div>
                    </Link>
                    <Link className={classNames.link} to="billwurtz">
                        <div>bill wurtz content</div>
                    </Link>
                    <a
                        className={classNames.link}
                        href="https://soundcloud.com/zach-halasz"
                    >
                        my soundcloud
                    </a>
                </div>
            </div>
        </div>
    );
}
